import React, { useState } from 'react'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/Images/Logo.png'
import Logo2 from '../../assets/Images/LogoBlue.png'
import { Button, Button1 } from './StyleComponent';
import { HiArrowLongRight } from "react-icons/hi2";
import { useAPIContextHook } from '../../Context/ApiContext';
import { CiUser } from "react-icons/ci";
import { RxHamburgerMenu } from "react-icons/rx";
import { AiOutlineClose } from "react-icons/ai";
import './PublicNavbar.css'
import styled from 'styled-components';
import Claim from '../../assets/claim_image.png'

const DropDownButton =styled.button`
background: none;
border: none;
outline: none;
width: 100%;
:hover{
  background: none;
}
`
const Banner = styled.div`

  background: #F7A601;
  display: flex;
  align-items: center;
  justify-content: center;

  div{
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  p{
    font-size: 100%;
    font-weight: 700;
    margin-bottom: 0px;
    color: black;
  }
  .claim-button{
    text-decoration: none;
    color: #080F1A;
    font-weight: 600;
    font-size: 90%;
    background: white;
    padding: 7px 10px;
    cursor: pointer;
    border-radius: 50px;
        text-align: center;
  }
`;
function PublicNavbar() {
const {cryptoCurrencyOptions} = useAPIContextHook();
  const [toggleClick, setToggleClick] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  console.log("cryptoCurrencyOptions", cryptoCurrencyOptions);

  const getNavbarColor = () => {
    if (location.pathname === '/' || location.pathname === '/home' || location.pathname === '/about') {
      return ['#08021C', 'white', 'white'];
    } else {
      return ['#ffffff', 'dark', '#1476FF'];
    }
  };
  
  const getLogo = () => {
    if (location.pathname === '/' || location.pathname === '/home' || location.pathname === '/about') {
      return Logo;
    } else {
      return Logo2;
    }
  }
  const HandLeft =(string)=>{
    navigate('/login')
    localStorage.setItem('pending-route',string)
  }

  const navOption = [
    {
      name: 'Gift Card',
      link: '/dashboard/wallet'
    },
    {
      name: 'Wallet',
      link: '/dashboard/wallet'
    }
  ]
  return (<div className="position-sticky top-0" style={{zIndex: '2'}}>
    {/* <Banner>
      <div>
        <img src={Claim} width="90px"/>
        <p>Launch Rush Airdrop : SIGN UP to earn 5 USDT!</p>
      </div>
      <a className='claim-button'>Claim Rewards</a>
    </Banner> */}
    <Navbar expand="xl" style={{ backgroundColor: getNavbarColor()[0] }}>
      <div className='container-fluid px-sm-5'>
        <Navbar.Brand className='d-flex align-items-center' as={Link} to="/home"><img src={getLogo()} alt={Logo} /></Navbar.Brand>
        <div className='d-flex d-xl-none flex-end align-items-center'>
          <Nav.Link className={`d-xl-none px-0`} as={Link} to="signup"><Button1>Sign Up<HiArrowLongRight className='ms-2' size={20} /></Button1></Nav.Link>
          
          <Dropdown>
            <Dropdown.Toggle className='outline-none bg-transparent border-0'  id="dropdown-basic">
            {toggleClick ? <AiOutlineClose size={24} /> : <RxHamburgerMenu size={24} />}
            </Dropdown.Toggle>
            <Dropdown.Menu align='end'>
              <Dropdown.Item className={`fw-bold text-start text-black`} onClick={()=>HandLeft('/dashboard/wallet')}>Buy Crypto</Dropdown.Item>
              <Dropdown.Item className={`fw-bold text-start text-black`} onClick={()=>HandLeft('/dashboard/wallet')}>Sell Crypto</Dropdown.Item>
              {
                navOption.map((data)=>{
                  return <Dropdown.Item className={`fw-bold text-start text-black`} onClick={()=>HandLeft(data.link)}>{data.name}</Dropdown.Item>
                })
              }
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="mx-auto d-none d-xl-flex gap-2">
          <NavDropdown
          className='fw-bold'
          role='button'
          title={<span className={`text-${getNavbarColor()[1]}`}>Trade</span>}
          id="basic-nav-dropdown"
          >
          {/* Buy Submenu */}
          <div className="dropdown-submenu">
          <NavDropdown.Item className='submenu-trigger'>Buy {">"}</NavDropdown.Item>
          <div className="submenu">
            {cryptoCurrencyOptions.map((data) => (
              <NavDropdown.Item
                as={Link}
                key={data._id}
                onClick={() => HandLeft(`/dashboard/buy/${data._id}`)}
              >
                {data.name}
              </NavDropdown.Item>
            ))}
          </div>
          </div>

          {/* Sell Submenu */}
          <div className="dropdown-submenu">
          <NavDropdown.Item className='submenu-trigger'>Sell {">"}</NavDropdown.Item>
          <div className="submenu">
            {cryptoCurrencyOptions.map((data) => (
              <NavDropdown.Item
                as={Link}
                key={data._id}
                onClick={() => HandLeft(`/dashboard/sell/${data._id}`)}
              >
                {data.name}
              </NavDropdown.Item>
            ))}
          </div>
          </div>
          </NavDropdown>

          <Nav.Link ><DropDownButton className={`fw-bold text-start text-${getNavbarColor()[1]}`}>Gift Card</DropDownButton></Nav.Link>
          <Nav.Link ><DropDownButton className={`fw-bold text-start text-${getNavbarColor()[1]}`}>Wallet</DropDownButton></Nav.Link>
          <NavDropdown className='fw-bold' title={<span className={`text-${getNavbarColor()[1]}`}>Rewards</span>} id="basic-nav-dropdown">
            <DropDownButton><NavDropdown.Item role='button' as={Link} className='text-start'>Reward Center</NavDropdown.Item></DropDownButton>
            <DropDownButton><NavDropdown.Item role='button' as={Link} to={"/rewards"} className='text-start'>Referral Reward Program</NavDropdown.Item></DropDownButton>
          </NavDropdown>
          <Nav.Link as={Link} to={"https://qvani.com/blog/"} target='_blank' ><DropDownButton className={`fw-bold text-start text-${getNavbarColor()[1]}`}>Learn</DropDownButton></Nav.Link>
          <NavDropdown className='fw-bold' title={<span className={`text-${getNavbarColor()[1]}`}>Support</span>} id="basic-nav-dropdown">
            <DropDownButton><NavDropdown.Item role='button' as={Link} to={"https://discord.gg/jp2vgEeG6R"} target='_blank' className='text-start'>Discord</NavDropdown.Item></DropDownButton>
            <DropDownButton><NavDropdown.Item role='button' as={Link} to={"https://support.qvani.com/en/"} target='_blank' className='text-start'>Help Center</NavDropdown.Item></DropDownButton>
          </NavDropdown>
        </div>
        <div className='d-none d-xl-flex'>
          <Nav.Link className='pe-0' as={Link} to='/login'>
            <Button className={`text-${getNavbarColor()[1]}`}>Log in</Button>
          </Nav.Link>
          <Nav.Link as={Link} to={'/signup'}>
            <Button1>Sign Up<HiArrowLongRight className='ms-2' size={20} /></Button1>
          </Nav.Link>
        </div>
      </div>
    </Navbar>
    </div>
  )
}

export default PublicNavbar;